import React, { FC, useState } from "react";

import { useWorkFilterOptions } from "../../../hooks/useWorkFilterOptions";
import { WorkFiltersBase } from "../../works/components/WorkFiltersBase";
import { WorksFilters } from "../../works/types/work-filters";

type Props = {
  setFilters: React.Dispatch<React.SetStateAction<WorksFilters>>;
  filters: WorksFilters;
};

export const ContactWorksFilters: FC<Props> = ({ setFilters, filters }) => {
  const [searchWorkTypes, setSearchWorkTypes] = useState("");

  const {
    usersOptions,
    statusesOptions,
    workTypeOptions,
    isLoadingUsers,
    isLoadingStatuses,
    isLoadingWorkTypes,
  } = useWorkFilterOptions({
    includeUsers: true,
  });

  return (
    <WorkFiltersBase
      filters={filters}
      setFilters={setFilters}
      workTypeOptions={workTypeOptions}
      statusesOptions={statusesOptions}
      usersOptions={usersOptions}
      isLoadingWorkTypes={isLoadingWorkTypes}
      isLoadingStatuses={isLoadingStatuses}
      isLoadingUsers={isLoadingUsers}
      searchWorkTypes={searchWorkTypes}
      setSearchWorkTypes={setSearchWorkTypes}
      showFilters={["work-type", "users", "status"]}
      className={"w-fit"}
    />
  );
};
